const getDiff = (difficulty) => {
  switch (difficulty) {
    case "Très Facile": return 1
    case "Facile": return 2
    case "Moyen": return 3
    case "Difficile": return 4
    case "Très Difficile": return 5
    default: return 1
  }
}

export default getDiff 